<template>
  <div class="layout" ref = "root">
      <!-- 顶部导航 -->
      <SiteHeader  :is_login_page="false"/>
      <div class="content">
        <div class="card-detail">
          <div class="left" ref="siblingDiv" >
            <div class="avatar_container">
              <img :src="card.avatar" alt="头像" class="avatar">
            </div>
            <div class="name">{{ card.name }}</div>
            <div class="features">
              <div class="item_title features_title">师资亮点</div>
              <div class="item_content features_content">{{ replaceCommaWithNewline(card.features) }}</div>
            </div>
            <div class="title">
              <div class="item_title  title_title">头衔/职务</div>
              <div class="item_content center_content features_content">{{ card.title }}</div>
            </div>
          </div>
          <div class="right" ref="dynamicDiv">
            <div class="base_info item_layout_row">
              <div class="country item_layout_row">
                <div class="item_title">国籍：</div>
                <div class="item_content">{{ card.country }}</div>
              </div>
              <div class="living_city item_layout_row">
                <div class="item_title">常驻地：</div>
                <div class="item_content">{{ card.living_city }}</div>
              </div>
              <div class="teacher_age item_layout_row">
                <div class="item_title">从业/授课年限：</div>
                <div class="item_content">{{ card.teacher_age }}</div>
              </div>
            </div>
            <!-- <div class="domain_info item_layout_row">
              <div class="course item_layout_row">
                <div class="item_title">教授课程：</div>
                <div class="item_content">{{ card.courses }}</div>
              </div>
              <div class="teach_domain item_layout_row">
                <div class="item_title">可授课领域：</div>
                <div class="item_content teach_domain_content">{{ card.teach_domain }}</div>
              </div>
            </div> -->
            <div class="teach_domain item_layout_col">
                <div class="item_title">可授课领域：</div>
                <div class="item_content teach_domain_content">{{ card.teach_domain }}</div>
            </div>
            <div class="course item_layout_col">
                <div class="item_title">教授课程：</div>
                <div class="item_content">{{ card.courses }}</div>
              </div>
            <div class="academic_domain item_layout_col">
                <div class="item_title">学术领域：</div>
                <div class="item_content academic_domain_content">{{ card.academic_domain }}</div>
            </div>
            <div class="achievements item_layout_col">
              <div class="item_title">著作及研究成果：</div>
              <div v-html="replaceNewLines(card.achievements)" class="item_content achievements_content"></div>
            </div>
            <div class="line"></div>
            <div class="resume">
              <div class="teach_resume item_layout_col">
                <div class="item_title">师资简历：</div>
                <div v-html="replaceNewLines(card.teach_resume)" class="item_content resume_content"></div>
              </div>
              <div class="private_resume item_layout_col">
                <div class="item_title">个人经历介绍：</div>
                <div v-html="replaceNewLines(card.private_resume)" class="item_content resume_content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 版权信息 -->
      <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue';
import SiteHeader from '@/components/SiteHeader.vue';
import axios from 'axios';
export default {
  name: 'CardDetail',
  components: {
      SiteFooter,
      SiteHeader
  },
  props: ['t_id'], // 接收路由参数
  data() {
    return {
      card: null,
    };
  },
  created() {
    console.log("begin");
    console.log(this.$route.path);
    console.log("end");
    this.verifyToken();
    console.log(this.t_id)
    this.getDetail();
  },
  mounted() {
    this.updateSiblingHeight();
  // 监听窗口变化，确保响应式
    window.addEventListener("resize", this.updateSiblingHeight);
  },
  updated() {
    this.updateSiblingHeight();
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener("resize", this.updateSiblingHeight);
  },
  methods: {
    replaceNewLines(str) {
      if(str)
      {
        return str.replace(/\n/g, '<br>');
      }
      else{
        return "";
      }
    },
    updateSiblingHeight() {
      const dynamicDiv = this.$refs.dynamicDiv;
      const siblingDiv = this.$refs.siblingDiv;
      const root = this.$refs.root;
      if (dynamicDiv && siblingDiv) {
        // 获取第一个 div 的高度，并设置为第二个 div 的高度
        siblingDiv.style.height = `${dynamicDiv.offsetHeight}px`;
        let rootheight = dynamicDiv.offsetHeight + 87 + 93 + 60 +76;
        root.style.height = `${rootheight}px`;
      }
    },
    replaceCommaWithNewline(text) {
      return text.replace(/,/g, '\n');
    },
    async verifyToken(){
    try {
          let token = localStorage.getItem('token'); // 存储 token
          const response = await axios.get('https://pay.4reasons.cn/teacher-user/verify-token', {
            headers: {
                'Authorization': 'Bearer '+token, 
            }
          });

          let code = response.data.code;
          console.log(response.data)
          if( code != '1000' )
          {
            this.$router.push(`/login`);
          }
      } catch (error) {
          console.error(error);
      }
  },
    async getDetail(){
      try {
          let token = localStorage.getItem('token'); // 存储 token
          const response = await axios.get('https://pay.4reasons.cn/teacher-user/detail', {
            headers: {
                'Authorization': 'Bearer '+token, 
              },
              params: {
                t_id: this.t_id
              }
          });

          let code = response.data.code;
          console.log(response.data)
          if( code == '1000' )
          {
            this.card = response.data.data
            if(this.card.avatar == null)
            {

              this.card.avatar = "";
            }
            if(this.card.tag == null)
            {

              this.card.tag = "";
            }
          }
      } catch (error) {
          console.error(error);
      }
    },
    goBack() {
      this.$router.push('/newhome'); // 返回主页
    },
  },
};
</script>

<style scoped>
* { 
  margin: 0; 
  padding: 0; 
  box-sizing: border-box; 
}
body{
  margin:0; 
  padding:0; 
  box-sizing: border-box; 
  background-color: #F5F5F5;
}
.layout {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* min-height: 100vh; */
  font-family: Arial, sans-serif;
  background-color: #F5F5F5;
  /* border: 1px solid red; */
}
.item_title{
  font-family: AlibabaPuHuiTi-Medium;
  font-weight: 500;
  font-size: 22px;
  /* color: #454545; */
  color: #191919;
  line-height: 30px;
}
.item_content{
  font-family: AlibabaPuHuiTi-Regular;
  font-weight: 500;
  font-size: 22px;
  color: #454545;
  line-height: 30px;
}
.item_layout_row{
  display:flex;
  flex-direction: row;
  justify-content: flex-start;
}
.item_layout_col{
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  gap:15px;
}
.features_title{
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  /* border: 1px solid blue; */
}
.title_title{
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  /* border: 1px solid blue; */
}
.center_content{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.features_content{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width:240px;
  flex-wrap: wrap; 
  /* border: 1px solid blue; */
}
.achievements{
  margin-top:25px;
  box-sizing: border-box; 
  width: 100%;
}
.achievements_content{
  width: 100%;
  /* overflow: scroll;
  overflow-x: hidden; */
  min-height: 100px;
  padding-bottom: 25px;
  box-sizing: border-box; 
}
.academic_domain{
  margin-top:25px;
}
.academic_domain_content{
  width: 100%;
}
.teach_domain_content{
  width: 100%;
}
.content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F5F5F5;
  width:100%;
}
.card-detail{
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: center;
margin-top:93px;
margin-bottom:60px;
min-height: 767px;
}
.left{
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
width:330px;
background-color: #ffffff;
border-radius: 10px;
min-height: 767px;
/* border: 1px solid blue; */
}
.right{
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: left;
width:1162px;
background-color: #ffffff;
border-radius: 10px;
min-height: 767px;
margin-left:28px;
padding-left:53px;
padding-right: 53px;
padding-top:46px;
padding-bottom:46px;
/* border: 1px solid blue; */
}
.avatar_container{
margin-top:46px;
}
.avatar{
width:162px;
height:162px;
}
.name{
margin-top:33px;
font-family: AlibabaPuHuiTi-Medium;
font-weight: 500;
font-size: 24px;
color: #191919;
line-height: 41px;
}
.features{
margin-top:32px;
display:flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap:15px;
}
.title{
margin-top:34px;
display:flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap:15px;
}
.base_info{
box-sizing: border-box; 
}
.country{
box-sizing: border-box; 
width: 405px;
/* border:1px solid blue; */
}
.living_city{
box-sizing: border-box; 
margin-left:53px;
width: 405px;
/* border:1px solid blue; */
}
.teacher_age{
box-sizing: border-box; 
margin-left:53px;
width: 405px;
/* border:1px solid blue; */
}
.domain_info{
margin-top:25px;
box-sizing: border-box; 
/* border:1px solid blue; */
}
.academic_domain{
box-sizing: border-box; 
width:100%;
/* border:1px solid blue; */
}
.teach_domain{
margin-top:25px;
box-sizing: border-box; 
width:100%;
}
.course{
margin-top:25px;
box-sizing: border-box; 
width:100%;
/* border:1px solid blue; */
}
.line{
border-bottom: 1px solid #C3C3C3;
}
.resume{
/* overflow: scroll; */
display: flex;
flex-direction: column;
/* overflow-x: hidden; */
margin-top:45px;
}
.teach_resume{
  
}
.private_resume{
 
margin-top:45px;
}
.resume_content{
  line-height:36px;
  width: 100%;
}
</style>